import { string } from 'prop-types';
import styled from 'styled-components';
import logoSrc from '../assets/images/se-logo.svg';

const LogoImg = styled.img`
  width: 4.5rem;
  height: auto;
`;

function Logo({ className }) {
  return (
    <LogoImg className={className} src={logoSrc} alt="Logo" />
  );
}

Logo.propTypes = {
  className: string,
};

Logo.defaultProps = {
  className: '',
}

export default styled(Logo)``;